import type { AppRuntimeData } from '@wix/ambassador-devcenter-appsruntimereader-v1-app-runtime-data/types';
import type { IComponent, ComponentType } from './types';

/**
 * Represents a facade for GetAppsRuntimeDataResponse type on the apps-runtime-reader service.
 * Mirrors the AppComponents facade (app-components.ts) — once specs.app-market.MigrateAppHaveEditorComponentToRuntimeReader
 * is merged, AppComponents (app-components.ts) and AppsComponents (apps-components.ts) can be deleted.
 *
 * @class AppRuntimeComponents
 */
export class AppRuntimeComponents {
  constructor(private readonly appRuntimeData: AppRuntimeData | undefined) {}

  get id(): string {
    return this.appRuntimeData?.appId ?? '';
  }

  get components(): IComponent[] {
    return (
      this.appRuntimeData?.components?.map((component) => ({
        compType: component.type as ComponentType,
      })) ?? []
    );
  }
}
